import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { getCoreDataSecurityMonitorsSlice } from '../get';
import { muteDataSecurityMonitorById } from '@api/data-security';
import { updateCoreDataSecurityMonitorsByApplicationSyncSlice } from '../application/update';
import { updateCoreDataSecurityMonitorsSyncSlice } from '../update';

export const muteCoreDataSecurityMonitorsSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		preRequestActionCreators: [
			updateCoreDataSecurityMonitorsSyncSlice.syncActionCreator
		],
		successActionCreators: [
			getCoreDataSecurityMonitorsSlice.asyncActionCreators.repeatGetCoreDataSecurityMonitors
		],
		successCombinationActionCreators: [
			updateCoreDataSecurityMonitorsByApplicationSyncSlice.syncActionCreator
		]
	},
	name: 'MuteCoreDataSecurityMonitorsById',
	receive: false,
	request: true,
	requestHandler: muteDataSecurityMonitorById
});
